import { ColumnProps } from "./Grid.types";

export function Column({ children, className }: ColumnProps) {
  return <div className={`col ${className ? className : ""}`}>{children}</div>;
}
